import { dialog } from "../../../nq-component";
import React, { useState } from "react";

function DialogConfirmation({
  handleAssign,
  object,
  title,
  type,
  handleConfirm,
  onchange,
}) {
  const [remarks, setRemarks] = useState("");
  return (
    <>
      <div className="p-4">
        <div className="d-flex flex-column">
          <div className="d-flex gap-3">
            <i
              class="bi bi-question-circle fs-2 px-2 py-1 rounded"
              style={{ backgroundColor: "#F5F5F5", color: "#D18237" }}
            ></i>
            <h5
              className="fw-bold align-self-center"
              style={{ color: "#D18237" }}
            >
              {title}
            </h5>
          </div>
          <div className="d-flex flex-column mx-5">
            {type ? (
              <div className="ms-2 me-1 mt-1">
                <p className="text-muted">
                  Are you sure you want to {type} this application?
                </p>
                <div
                  className="mt-2 d-flex border border-1 align-content-center rounded-1 p-3 gap-2 justify-content-center"
                  style={{ backgroundColor: `#DBDBDB` }}
                >
                  <p
                    className="text-muted m-0 text-truncate"
                    style={{ fontSize: `0.8rem` }}
                  >
                    {object?.firstName +
                      " " +
                      object?.middleName +
                      " " +
                      object?.lastName}
                  </p>

                  <p
                    className="m-0 text-truncate"
                    style={{ fontSize: `0.8rem` }}
                  >
                    (
                    <span style={{ color: `#D18237` }}>
                      {object?.positionApplied}
                    </span>
                    )
                  </p>
                </div>

                {type === "reject" ? (
                  <div className="mt-3">
                    <label>
                      <b>Remarks</b>
                      <span className="text-danger fw-lighter ms-1">*</span>
                    </label>
                    <textarea
                      className="w-100 rounded-1 p-2"
                      placeholder="Enter remarks here..."
                      style={{
                        fontSize: "0.9rem",
                        maxHeight: "170px",
                        minHeight: "5 0px",
                      }}
                      // rows="3"
                      onChange={(e) => {
                        onchange(e);
                        setRemarks(e.target.value);
                      }}
                      onInput={(e) => {
                        e.target.style.height = "auto";
                        e.target.style.height = `${Math.min(
                          e.target.scrollHeight,
                          150
                        )}px`;
                      }}
                    ></textarea>
                  </div>
                ) : (
                  ""
                )}
              </div>
            ) : (
              <div className="ms-2 me-1 mt-1">
                <p className="text-muted">
                  Are you sure you want to print consent form?
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="text-center mb-3 d-flex justify-content-center gap-2">
        {type === "reject" ? (
          <button
            type="submit"
            className="btn text-white px-5"
            style={{
              backgroundColor: remarks === "" ? "#d1823775" : "#D18237",
            }}
            onClick={handleConfirm}
            disabled={remarks === ""}
          >
            Confirm
          </button>
        ) : (
          <button
            type="submit"
            className="btn text-white px-5"
            style={{
              backgroundColor: "#D18237",
            }}
            onClick={handleConfirm}
          >
            Confirm
          </button>
        )}

        <button
          className="btn px-5"
          style={{ backgroundColor: "#e8ecf3" }}
          onClick={() => dialog.close()}
        >
          Cancel
        </button>
      </div>
    </>
  );
}

export default DialogConfirmation;
